"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawEventDataToJSON = exports.RawEventDataFromJSONTyped = exports.RawEventDataFromJSON = void 0;
var runtime_1 = require("../runtime");
function RawEventDataFromJSON(json) {
    return RawEventDataFromJSONTyped(json, false);
}
exports.RawEventDataFromJSON = RawEventDataFromJSON;
function RawEventDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'gameId': json['gameId'],
        'gameTitle': json['gameTitle'],
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : json['data'],
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
exports.RawEventDataFromJSONTyped = RawEventDataFromJSONTyped;
function RawEventDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'gameId': value.gameId,
        'gameTitle': value.gameTitle,
        'data': value.data,
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.RawEventDataToJSON = RawEventDataToJSON;
